import { createReducer, on } from '@ngrx/store';
import { Action } from '../../models';
import {
  resetPaymentGatewayStore,
  setBillMetaInfoAction,
  setPaymentGatewayAction,
} from '../actions/paymentGateway.actions';

export interface BillMetaInfoProps {
  ref: string;
  billReference: string;
  tpui: string;
  userType:
    | 'mda'
    | 'admin'
    | 'tax-office'
    | 'expert-system'
    | 'logged-in-user'
    | 'guest-user'
    | 'governor'
    | 'tsp';
  // Gateways that should not be offered for this bill
  hiddenGateways?: ('bank' | 'remita' | 'interswitch')[];
}

export interface PaymentGatewayInitialState {
  openPaymentGateway: boolean | null;
  billInfo: BillMetaInfoProps | null;
}

export const initialState: PaymentGatewayInitialState = {
  openPaymentGateway: null,
  billInfo: null,
};

const reducer = createReducer(
  initialState,
  on(setPaymentGatewayAction, (state, payload) => {
    return {
      ...state,
      ...payload,
    };
  }),
  on(setBillMetaInfoAction, (state, payload) => {
    const { openPaymentGateway, type, ...others } = payload;

    return {
      ...state,
      ...(!!openPaymentGateway ? { openPaymentGateway } : {}),
      billInfo: {
        ...state.billInfo,
        ...others,
      },
    };
  }),
  on(resetPaymentGatewayStore, () => {
    return initialState;
  })
);

export function paymentGatewayReducer(
  state: PaymentGatewayInitialState,
  action: Action
) {
  return reducer(state, action);
}
